var portfolio = {
	addTransactionAction: "Transaktion hinzufügen",
	topFlopTitle: "Top/Flop Position",
	breakdownsTitle: "Informationen der Zusammensetzung",
	assetClassBreakdownTitle: "Anlageklassen",
	currencyBreakdownTitle: "Währungen",
	sectorBreakdownTitle: "Sektoren",
	sectorBreakdownSubtitle: "Gewichtung im Gesamtportfolio",
	evaluationChartTitle: "Portfoliowert",
	unrealizedPerformancePositionsTitle: "Nicht realisierte G u V",
	weightPositionsTitle: "Portfoliogewicht",
	editPortfolioAction: "Portfolio bearbeiten",
	deletePortfolioAction: "Portfolio löschen",
	createPortfolioAction: "Portfolio erstellen",
	addPortfolioAction: "Portfolio erstellen",
	editTransactionAction: "Transaktion bearbeiten",
	deleteTransactionAction: "Transaktion löschen",
	errorAlertLabel: "Ein Fehler ist aufgetreten",
	transactionLimitExceeded: "Transaktionslimit überschritten",
	portfolioLimitExceeded: "Portfoliolimit überschritten",
	info: "Information",
	noPositionsAlert: "Das Portfolio enthält keine Positionen, bitte fügen Sie eine Kauftransaktion hinzu.",
	noTransactionsAlert: "Das Portfolio enthält keine Transaktionen, bitte fügen Sie eine Kauftransaktion hinzu.",
	noPortfolios: {
		title: "Info",
		message: "Es wurde noch kein Portfolio erstellt. Klicken Sie bitte auf die Schaltfläche \"Portfolio hinzufügen\" und füllen Sie das Formular aus um ein Portfolio zu erstellen."
	},
	tab: {
		overview: "Überblick",
		positions: "Positionen",
		transactions: "Transaktionen",
		news: "Nachrichten"
	},
	showActions: "Aktionen anzeigen"
};
var de = {
	portfolio: portfolio
};

export { de as default, portfolio };
